/* eslint-disable react/prop-types */
import React, { Component } from "react";
import {
  Grid, Segment, Form, Input, Button, Divider,
  Dimmer, Loader, Modal, Icon, Header, Popup,
  Dropdown, Checkbox
} from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import UpdateLoader from "./UpdateLoader";
import Strings from "../utilities/StringSelector";
import Constants from "../utilities/Constants";
import Utils from "../utilities/Utils";
import sha256 from "js-sha256";
import Timezones from "../utilities/Timezones";

const UtilsInstance = new Utils();

class Configuration extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      tag: "",
      ntpAddr: "",
      isNtpActive: false,
      ntpCheckboxLabel: Strings.TURNED_OFF,
      timezone: "",
      isDimmerActive: false,
      isResetMediaCountersDimmerActive: false,
      isResetInterfaceCountersDimmerActive: false,
      isUpdateDimmerActive: false,
      isResetLogDimmerActive: false,
      updateStatus: Constants.NOT_UPDATING,
      ntpUpdate: Constants.NTP_UPDATE_NOT_STARTED,
      isRestartSystemModalOpen: false,
      isTagConfigDimmerActive: false,
      isNtpDimmerActive: false,
      isNtpModalOpen: false,
      ethernetText: JSON.parse(sessionStorage.getItem(Constants.WIFI_OR_ETHENET_KEY)) ? Strings.ETHERNET_INTERFACE : Strings.ETHERNET,
      wlanText: JSON.parse(sessionStorage.getItem(Constants.WIFI_OR_ETHENET_KEY)) ? Strings.OFFICE_INTERFACE : Strings.WLAN,
      wlanPopupText: JSON.parse(sessionStorage.getItem(Constants.WIFI_OR_ETHENET_KEY)) ? Strings.OFFICE_CONFIG_POPUP : Strings.WLAN_CONFIG_POPUP,
    };

    this.updateLoaderRef = React.createRef();
  }

  showDimmer = () => this.setState({ isDimmerActive: true })
  hideDimmer = () => this.setState({ isDimmerActive: false })

  showUpdateDimmer = () => this.setState({ isUpdateDimmerActive: true })
  hideUpdateDimmer = () => this.setState({ isUpdateDimmerActive: false })

  showRestartSystemModal = () => this.setState({ isRestartSystemModalOpen: true });
  hideRestartSystemModal = () => this.setState({ isRestartSystemModalOpen: false });

  showResetMediaCountersIncrementDimmer = () => this.setState({ isResetMediaCountersDimmerActive: true })
  hideResetMediaCountersDimmer = () => this.setState({ isResetMediaCountersDimmerActive: false })

  showResetInterfaceCountersIncrementDimmer = () => this.setState({ isResetInterfaceCountersDimmerActive: true })
  hideResetInterfaceCountersDimmer = () => this.setState({ isResetInterfaceCountersDimmerActive: false })

  showTagConfigDimmer = () => this.setState({ isTagConfigDimmerActive: true });
  hideTagConfigDimmer = () => this.setState({ isTagConfigDimmerActive: false });

  showNtpDimmer = () => this.setState({ isNtpDimmerActive: true });
  hideNtpDimmer = () => this.setState({ isNtpDimmerActive: false });

  showResetLogDimmer = () => this.setState({ isResetLogDimmerActive: true });
  hideResetLogDimmer = () => this.setState({ isResetLogDimmerActive: false });

  showNtpModal = () => this.setState({ isNtpModalOpen: true });
  hideNtpModal = () => this.setState({ isNtpModalOpen: false });

  retrieveData = async () => {
    let promissesArray = [];

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "tag", { mode: "cors" })
        .then(res => res.json())
        .then(data => data.tag)
    );

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "ntp", { mode: "cors" })
        .then(res => res.json())
        .then(data => data)
    );

    let resolvedPromisses = await Promise.all(promissesArray);

    this.setState({
      tag: resolvedPromisses[0],
      ntpAddr: resolvedPromisses[1].ntpIp,
      isNtpActive: resolvedPromisses[1].ntp,
      timezone: resolvedPromisses[1].timezone,
      ntpCheckboxLabel: resolvedPromisses[1].ntp ? Strings.TURNED_ON : Strings.TURNED_OFF
    });

  }

  handleTagChange = (e, { value }) => {
    this.setState({ tag: value });
  }

  handleNTPAddressChange = (e, { value }) => {
    this.setState({ ntpAddr: value });
  }

  toggleNtpActive = () => {
    this.setState({
      ntpCheckboxLabel: !this.state.isNtpActive ? Strings.TURNED_ON : Strings.TURNED_OFF,
      isNtpActive: !this.state.isNtpActive
    });
  }

  sendTag = () => {
    this.showTagConfigDimmer();

    fetch(Constants.REQUEST_IP_ADDRESS + "tag_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: JSON.stringify({ tag: this.state.tag })
    })
      .then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.TAG_WAS_CHANGED_SUCCESSFULLY);
      })
      .catch((error) => {
        alert(Strings.TAG_CHANGE_FAILURE + "\n" + Strings.REASON_DP + error);
      })
      .finally(this.hideTagConfigDimmer);
  }

  //Sends a .gpg file to the server to update the monitor software
  sendFile = () => {
    let input = document.querySelector("input[type=\"file\"]");
    // If the file exists and doesn't contain ".gpg" in its name
    if (input.files[0] !== undefined && input.files[0] !== null) {
      if (input.files[0].name.indexOf(Constants.GPG_FILE_EXTENSION) === -1) {
        alert(Strings.GPG_ALERT_MESSAGE);
      }
      else {
        let data = new FormData();
        let reader = new FileReader();
        let sha256Checksum = "";

        reader.onload = (event) => {
          sha256Checksum = sha256(event.target.result);

          data.append("updateFile", input.files[0]);
          data.append("checkSum", sha256Checksum);

          this.showDimmer();

          fetch(Constants.REQUEST_IP_ADDRESS + "sendFile_POST", {
            method: "POST",
            body: data
          })
            .then(UtilsInstance.checkStatus)
            .then(() => {
              this.handleUpdateCycles(Constants.FILE_UPDATE_TYPE);
            })
            .catch((error) => {
              if (error.response.status === 415) {
                alert(Strings.SEND_FILE_FAILURE + "\n" + Strings.REASON_DP + Strings.SEND_FILE_WRONG_FILENAME);
              }
              else if (error.response.status === 417) {
                alert(Strings.SEND_FILE_FAILURE + "\n" + Strings.REASON_DP + Strings.SEND_FILE_CORRUPTED_FILE);
              }
              else {
                alert(Strings.SEND_FILE_FAILURE + "\n" + Strings.REASON_DP + error);
              }
            })
            .finally(this.hideDimmer);
        };

        reader.onerror = (event) => {
          reader.abort();
          alert(Strings.SEND_FILE_FAILURE + "\n" + Strings.REASON_DP + event);
        };

        reader.readAsArrayBuffer(input.files[0]);
      }
    }
    else {
      alert(Strings.SELECT_FILE);
    }
  }

  logOut = () => {
    sessionStorage.removeItem("auth");
    this.props.history.push({ pathname: "/login-handler" });
  }

  generateReport = () => {
    this.props.history.push({ pathname: "/report" });
  }

  // Verifies if the user has the credentials to be logged in
  // If he does he is re-directed to the configuration page
  // If he doesn't he is re-directed to the login page
  isUserLoggedIn = () => {
    if (sessionStorage.auth !== Constants.AUTH_STR) {
      this.props.history.push({ pathname: "/login" });
    }
  }

  changeLoginInfo = () => {
    this.props.history.push({ pathname: "/change-login" });
  }

  configureTsExpert = () => {
    this.props.history.push({ pathname: "/ts-expert-config" });
  }

  handleUpdateCycles = (updateType) => {
    this.showUpdateDimmer();
    let intervalID = -1;

    if (updateType === Constants.FILE_UPDATE_TYPE) {
      this.updateLoaderRef.current.changeLoaderText(Strings.DO_NOT_CLOSE_THIS_TAB, "");
      intervalID = setInterval(this.handleUpdateFilesStatus, 2000);
    }
    else if (updateType === Constants.NTP_UPDATE_TYPE) {
      this.updateLoaderRef.current.changeLoaderText(Strings.SEND_NTP_CONFIG_DONE, "");
      intervalID = setInterval(this.handleUpdateNtpStatus, 2000);
    }
    // store intervalId in the state so it can be accessed later
    this.setState({ intervalID: intervalID });
  }

  handleUpdateFilesStatus = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "updateStatus", { mode: "cors" })
      .then(res => res.json())
      .then((data) => {

        console.log("Status atual da tela: ", this.state.updateStatus);
        console.log("Data update Status: ", data.update);

        if (this.state.updateStatus === Constants.NOT_UPDATING && data.update === Constants.UPDATE_FILES_FOUND) {
          this.setState({ updateStatus: data.update }, () => {
            this.updateLoaderRef.current.changeLoaderText(Strings.DO_NOT_CLOSE_THIS_TAB, Strings.UPDATING_MONITOR_FILES);
          });
        }
        else if (this.state.updateStatus === Constants.UPDATE_FILES_FOUND && data.update === Constants.FINISHED_UPDATING) {
          this.setState({ updateStatus: data.update }, () => {
            this.updateLoaderRef.current.changeLoaderText(Strings.DO_NOT_CLOSE_THIS_TAB, Strings.MONITOR_FILES_UPDATED_SUCCESSFULLY);
          });
        }
        else if (this.state.updateStatus === Constants.FINISHED_UPDATING && data.update === Constants.RESTARTING_MONITOR) {
          this.setState({ updateStatus: data.update }, () => {
            this.updateLoaderRef.current.changeLoaderText(Strings.DO_NOT_CLOSE_THIS_TAB, Strings.RESTARTING_MONITOR_WAIT);
          });
        }
        else if (this.state.updateStatus === Constants.RESTARTING_MONITOR && data.update === Constants.NOT_UPDATING) {
          this.setState({ updateStatus: data.update }, () => {
            this.updateLoaderRef.current.changeLoaderText(Strings.DO_NOT_CLOSE_THIS_TAB, "");
            this.hideUpdateDimmer();
            clearInterval(this.state.intervalID);
            alert(Strings.UPDATE_SUCCESS);
            this.retrieveData();
          });
        }
      })
      .catch((error) => {
        console.log(Strings.UPDATE_ERROR_STRING + error);
      });
  }

  handleUpdateNtpStatus = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "updateStatus", { mode: "cors" })
      .then(res => res.json())
      .then((data) => {

        console.log("Status atual da tela: ", this.state.updateStatus);
        console.log("Data update Status: ", data.update);

        if (this.state.updateStatus === Constants.NOT_UPDATING && data.update === Constants.RESTARTING_MONITOR) {
          this.setState({ updateStatus: data.update }, () => {
            this.updateLoaderRef.current.changeLoaderText(Strings.SEND_NTP_CONFIG_DONE, Strings.RESTARTING_MONITOR_WAIT);
          });
        }
        else if (this.state.updateStatus === Constants.RESTARTING_MONITOR && data.update === Constants.NOT_UPDATING) {
          this.setState({ updateStatus: data.update }, () => {
            this.updateLoaderRef.current.changeLoaderText(Strings.SEND_NTP_CONFIG_DONE, "");
            this.hideUpdateDimmer();
            clearInterval(this.state.intervalID);
            alert(Strings.MONITOR_RESTART_SUCCESS);
            this.retrieveData();
          });
        }
      })
      .catch((error) => {
        console.log(Strings.MONITOR_RESTART_FAILURE + error);
      });

  }

  handleRestartSystemModalPositiveClick = () => {
    let data = JSON.stringify({
      reset: "True"
    });

    fetch(Constants.REQUEST_IP_ADDRESS + "restartSystem_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: data,
      mode: "cors"
    }).then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.RESTART_SYSTEM_SUCCESS);
      })
      .catch(function (error) {
        alert(Strings.RESTART_SYSTEM_FAILURE + "\n" + Strings.REASON_DP + error);
      })
      .finally(this.hideRestartSystemModal);
  }

  resetMediaCountersIncrement = () => {
    let data = JSON.stringify({
      reset: "True"
    });

    this.showResetMediaCountersIncrementDimmer();

    fetch(Constants.REQUEST_IP_ADDRESS + "resetMediaCountersIncrements_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: data
    }).then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.RESET_MEDIA_COUNTERS_INCREMENT_SUCCESS);
      })
      .catch((error) => {
        alert(Strings.RESET_MEDIA_COUNTERS_INCREMENT_FAILURE + "\n" + Strings.REASON_DP + error);
      })
      .finally(this.hideResetMediaCountersDimmer);
  }

  resetInterfaceCountersIncrement = () => {
    let data = JSON.stringify({
      reset: "True"
    });

    this.showResetInterfaceCountersIncrementDimmer();

    fetch(Constants.REQUEST_IP_ADDRESS + "resetInterfaceCountersIncrement_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: data
    }).then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.RESET_INTERFACE_COUNTERS_INCREMENT_SUCCESS);
      })
      .catch((error) => {
        alert(Strings.RESET_INTERFACE_COUNTERS_INCREMENT_FAILURE + "\n" + Strings.REASON_DP + error);
      })
      .finally(this.hideResetInterfaceCountersDimmer);
  }

  openEthernetPage = () => {
    this.props.history.push({ pathname: "/ethernet-config" });
  }

  openWLANPage = () => {
    if (JSON.parse(sessionStorage.getItem(Constants.WIFI_OR_ETHENET_KEY))) {
      this.props.history.push({ pathname: "/office-ethernet-config" });
    }
    else {
      this.props.history.push({ pathname: "/wlan-config" });
    }
  }

  openSweepPage = () => {
    this.props.history.push({
      pathname: "/sweep"
    });
  }

  handleTurnNtpServerOnModalPositiveClick = () => {
    this.hideNtpModal();
    this.updateNtpServer();
  }

  saveNtpServerInfo = () => {
    let isIpValid = UtilsInstance.validateIPAddress(this.state.ntpAddr);
    let isIPLoopback = UtilsInstance.isIPLoopback(this.state.ntpAddr);

    // Verify the network information provided. Only send it if it passes the validation
    if (!isIpValid || isIPLoopback || this.state.timezone.length === 0) {
      let invalidInformationString = Strings.VERIFY_THE_FOLLOWING_INFO;

      // If the IP is not valid or if it is the loopback IP (127.0.0.1)
      if (!isIpValid) {
        invalidInformationString = invalidInformationString.concat(Strings.INVALID_IP);
      }
      else if (isIPLoopback) {
        invalidInformationString = invalidInformationString.concat(Strings.LOOPBACK_IP_NTP);
      }

      if (this.state.timezone.length === 0) {
        invalidInformationString = invalidInformationString.concat(Strings.SELECT_TIMEZONE);
      }

      alert(invalidInformationString);
    }
    else {
      // If the user is turning the ntp server off there is no need to ask
      // for permission to restart because the system will not restart
      if (this.state.isNtpActive === false) {
        this.updateNtpServer();
      }
      // If the user is turning the ntp server on we will need ask for permission
      // to restart the system
      else {
        this.showNtpModal();
      }
    }
  }

  updateNtpServer = () => {
    let data = JSON.stringify({
      ntp: this.state.isNtpActive,
      ntpIp: this.state.ntpAddr,
      timezone: this.state.timezone
    });

    if (this.state.isNtpActive === false) {
      this.showNtpDimmer();

      fetch(Constants.REQUEST_IP_ADDRESS + "ntp_POST", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: data
      })
        .then(UtilsInstance.checkStatus)
        .then(() => {
          this.updateNtpServerFirstStep();
        })
        .catch((error) => {
          console.log(error);
          alert(Strings.NTP_INFO_TURNED_OFF_FAILURE + "\n" + Strings.REASON_DP + Strings.NTP_INFO_FAILURE);
          this.toggleNtpActive();
        })
        .finally(this.hideNtpDimmer);
    }
    else {
      this.showNtpDimmer();

      fetch(Constants.REQUEST_IP_ADDRESS + "ntp_POST", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: data
      })
        .then(UtilsInstance.checkStatus)
        .then(() => {
          this.updateNtpServerFirstStep();
        })
        .catch((error) => {
          this.toggleNtpActive();
          console.log(error);
          alert(Strings.NTP_INFO_TURNED_ON_FAILURE + "\n" + Strings.REASON_DP + Strings.NTP_INFO_FAILURE);
        })
        .finally(this.hideNtpDimmer);
    }
  }

  updateNtpServerFirstStep = () => {
    let intervalID = -1;
    this.showUpdateDimmer();
    this.updateLoaderRef.current.changeLoaderText(Strings.PROCESSING_NTP_INIT, "");
    intervalID = setInterval(this.handleUpdateNtpFirstStep, 2000);
    // store intervalId in the state so it can be accessed later
    this.setState({ intervalID: intervalID });
  }

  handleUpdateNtpFirstStep = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "ntpUpdate", { mode: "cors" })
      .then(res => res.json())
      .then((data) => {

        console.log("Status atual da tela: ", this.state.ntpUpdate);
        console.log("Data update Status: ", data.ntpUpdate);

        if (this.state.ntpUpdate === Constants.NTP_UPDATE_NOT_STARTED && data.ntpUpdate === Constants.NTP_UPDATE_START) {
          this.setState({ ntpUpdate: data.ntpUpdate }, () => {
            this.updateLoaderRef.current.changeLoaderText(Strings.PROCESSING_NTP_INFO, "");
          });
        }
        else if (
          (this.state.ntpUpdate === Constants.NTP_UPDATE_NOT_STARTED || this.state.ntpUpdate === Constants.NTP_UPDATE_START)
          && data.ntpUpdate === Constants.NTP_UPDATE_SUCCESS
        ) {
          this.setState({ ntpUpdate: Constants.NTP_UPDATE_NOT_STARTED }, () => {
            this.updateLoaderRef.current.changeLoaderText(Strings.PROCESSED_NTP_INFO, "");
            clearInterval(this.state.intervalID);
            this.handleUpdateCycles(Constants.NTP_UPDATE_TYPE);
          });
        }
        else if (
          (this.state.ntpUpdate === Constants.NTP_UPDATE_NOT_STARTED || this.state.ntpUpdate === Constants.NTP_UPDATE_START)
          && data.ntpUpdate === Constants.NTP_UPDATE_FAIL
        ) {
          this.setState({ ntpUpdate: Constants.NTP_UPDATE_NOT_STARTED }, () => {
            this.hideUpdateDimmer();
            clearInterval(this.state.intervalID);
            alert(Strings.PROCESSING_NTP_ERROR);
            this.toggleNtpActive();
          });
        }
      })
      .catch(() => {
        this.hideUpdateDimmer();
        clearInterval(this.state.intervalID);
        this.setState({ ntpUpdate: Constants.NTP_UPDATE_NOT_STARTED });
        alert(Strings.PROCESSING_NTP_ERROR);
        this.toggleNtpActive();
      });
  }

  cleanLog = () => {
    let data = JSON.stringify({
      reset: "True"
    });

    this.showResetLogDimmer();

    fetch(Constants.REQUEST_IP_ADDRESS + "resetLog_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: data
    }).then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.CLEAN_LOG_SUCCESS);
      })
      .catch((error) => {
        alert(Strings.CLEAN_LOG_FAILURE + "\n" + Strings.REASON_DP + error);
      })
      .finally(this.hideResetLogDimmer);
  }

  onTimezoneDropdownChange = (e, { value }) => this.setState({ timezone: value })

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.isUserLoggedIn();
    this.retrieveData();
    this.setState({ updateStatus: Constants.NOT_UPDATING });
  }

  render() {
    const isDimmerActive = this.state.isDimmerActive;
    const isUpdateDimmerActive = this.state.isUpdateDimmerActive;
    const isResetMediaCountersDimmerActive = this.state.isResetMediaCountersDimmerActive;
    const isResetInterfaceCountersDimmerActive = this.state.isResetInterfaceCountersDimmerActive;
    const isTagConfigDimmerActive = this.state.isTagConfigDimmerActive;
    const isNtpDimmerActive = this.state.isNtpDimmerActive;
    const isResetLogDimmerActive = this.state.isResetLogDimmerActive;

    return (
      <div style={configPageStyle}>

        <div style={logoutButtonContainer}>
          <Button
            icon
            style={logoutButtonStyle}
            color="red"
            onClick={this.showRestartSystemModal}>
            <Icon name='power off' />
            {Strings.RESTART_SYSTEM}
          </Button>
          <Button style={logoutButtonStyle} color="grey" onClick={this.logOut}>{Strings.LOGOUT}</Button>
        </div>

        <Grid centered columns={2} doubling>
          <Grid.Column>

            <Segment>
              <Divider horizontal>{Strings.TAG_CONFIG}</Divider>
              <Form style={formStyle} onSubmit={this.sendTag}>

                <Form.Field inline>
                  <label style={labelStyle}>{Strings.TAG}</label>
                  <Input style={inputStyle}
                    placeholder={Strings.TEST_NETWORK}
                    value={this.state.tag}
                    onChange={this.handleTagChange} />
                </Form.Field>

                <Button color="teal" type="submit" >{Strings.SETUP}</Button>
              </Form>
              <Dimmer active={isTagConfigDimmerActive} >
                <Loader>{Strings.SEND_CONFIG_WAITING}</Loader>
              </Dimmer>
            </Segment>

            <Segment textAlign="center">
              <Divider horizontal>{Strings.NTP_SERVER}</Divider>

              <Form onSubmit={this.saveNtpServerInfo}>

                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", paddingBottom: "1vh" }}>
                  <div style={{ flexGrow: 2 }}>
                    <Form.Field>
                      <label>{Strings.IP}</label>
                      <Input
                        fluid
                        placeholder={Strings.NETWORK_IP_PLACEHOLDER}
                        value={this.state.ntpAddr}
                        onChange={this.handleNTPAddressChange} />
                    </Form.Field>

                    <Form.Field>
                      <label>{Strings.TIMEZONE}</label>
                      <Dropdown
                        fluid
                        placeholder={Strings.TIMEZONE}
                        search
                        selection
                        scrolling
                        options={Timezones.zones}
                        value={this.state.timezone}
                        onChange={this.onTimezoneDropdownChange} />
                    </Form.Field>
                  </div>
                  <div style={{ flexGrow: 1 }}>
                    <Form.Field>
                      <Checkbox
                        toggle
                        onClick={this.toggleNtpActive}
                        checked={this.state.isNtpActive}
                        label={this.state.ntpCheckboxLabel} />
                    </Form.Field>
                  </div>
                </div>

                <Button color="teal" type="submit">{Strings.SETUP}</Button>
              </Form>

              <Dimmer active={isNtpDimmerActive} >
                <Loader>{Strings.SEND_NTP_CONFIG_WAITING}</Loader>
              </Dimmer>
            </Segment>

            <Grid columns={2} doubling>

              <Grid.Column>
                <Segment style={updateSegmentStyle}>
                  <Divider horizontal>
                    {this.state.ethernetText}
                    <Popup position='top center' hoverable pinned wide
                      trigger={<Icon name="question circle" size="big" color="teal" style={questionIconStyle} />}>
                      <Popup.Content>
                        <p>{Strings.ETHERNET_POPUP_1}</p>
                        <p>{Strings.ETHERNET_POPUP_2}</p>
                      </Popup.Content>
                    </Popup>
                  </Divider>
                  <Button
                    content={Strings.SETUP}
                    color="teal"
                    onClick={this.openEthernetPage} />
                </Segment>
              </Grid.Column>

              <Grid.Column>
                <Segment style={updateSegmentStyle}>
                  <Divider horizontal>
                    {this.state.wlanText}
                    <Popup position='top center' hoverable pinned wide="very"
                      trigger={<Icon name="question circle" size="big" color="teal" style={questionIconStyle} />}>
                      <Popup.Content>
                        {this.state.wlanPopupText}
                      </Popup.Content>
                    </Popup>
                  </Divider>
                  <Button
                    content={Strings.SETUP}
                    color="teal"
                    onClick={this.openWLANPage} />
                </Segment>
              </Grid.Column>

            </Grid>

            <Grid columns={2} doubling>

              <Grid.Column>
                <Segment style={updateSegmentStyle}>
                  <Divider horizontal>{Strings.TS_EXPERT}</Divider>
                  <Button color="teal" onClick={this.configureTsExpert}>{Strings.SETUP}</Button>
                </Segment>
              </Grid.Column>

              <Grid.Column>
                <Segment style={updateSegmentStyle}>
                  <Divider horizontal>
                    {Strings.SWEEP}
                    <Popup position='top center' hoverable pinned wide
                      trigger={<Icon name="question circle" size="big" color="teal" style={questionIconStyle} />}>
                      <Popup.Content>
                        {Strings.SWEEP_POPUP_MSG}
                      </Popup.Content>
                    </Popup>
                  </Divider>
                  <Button id="sweep-page-button" color="teal" onClick={this.openSweepPage}>{Strings.SETUP}</Button>
                </Segment>
              </Grid.Column>

            </Grid>

          </Grid.Column>

          <Grid.Column>

            <Segment style={updateSegmentStyle}>
              <Divider horizontal>{Strings.SOFTWARE_UPDATE}</Divider>
              <p>{Strings.CURRENT_VERSION}<b>{Constants.TS_MONITOR_VERSION}</b></p>
              <Form style={formStyle} onSubmit={this.sendFile}>
                <Form.Input type="file" accept=".gpg"></Form.Input>
                <Button color="teal" type="submit" >{Strings.UPDATE}</Button>
              </Form>
              <Dimmer active={isDimmerActive} >
                <Loader>{Strings.SEND_FILE_WAITING}</Loader>
              </Dimmer>
            </Segment>

            <Grid columns={2} doubling>

              <Grid.Column>
                <Segment style={updateSegmentStyle}>
                  <Divider horizontal>{Strings.REPORT}</Divider>
                  <Button color="teal" onClick={this.generateReport}>{Strings.GENERATE_REPORT}</Button>
                </Segment>
              </Grid.Column>

              <Grid.Column>
                <Segment style={updateSegmentStyle}>
                  <Divider horizontal>{Strings.CHANGE_LOGIN}</Divider>
                  <Button color="teal" onClick={this.changeLoginInfo}>{Strings.CHANGE}</Button>
                </Segment>
              </Grid.Column>

            </Grid>

            <Grid columns={2} doubling>

              <Grid.Column>
                <Segment style={updateSegmentStyle}>
                  <Divider horizontal>{Strings.MEDIA_COUNTERS_INCREMENT}</Divider>
                  <Button color="teal" onClick={this.resetMediaCountersIncrement}>{Strings.CLEAR}</Button>
                  <Dimmer active={isResetMediaCountersDimmerActive} >
                    <Loader>{Strings.WAITING}</Loader>
                  </Dimmer>
                </Segment>
              </Grid.Column>

              <Grid.Column>
                <Segment style={updateSegmentStyle}>
                  <Divider horizontal>{Strings.INTERFACE_COUNTERS_INCREMENT}</Divider>
                  <Button color="teal" onClick={this.resetInterfaceCountersIncrement}>{Strings.CLEAR}</Button>
                  <Dimmer active={isResetInterfaceCountersDimmerActive} >
                    <Loader>{Strings.WAITING}</Loader>
                  </Dimmer>
                </Segment>
              </Grid.Column>

            </Grid>

            <Grid columns={2} doubling>

              <Grid.Column>
                <Segment style={updateSegmentStyle}>
                  <Divider horizontal>{Strings.LOG}</Divider>
                  <Button color="teal" onClick={this.cleanLog}>{Strings.CLEAR}</Button>
                  <Dimmer active={isResetLogDimmerActive} >
                    <Loader>{Strings.WAITING}</Loader>
                  </Dimmer>
                </Segment>
              </Grid.Column>

              <Grid.Column>
              </Grid.Column>

            </Grid>

          </Grid.Column>
        </Grid>

        <Modal basic size='small' open={this.state.isRestartSystemModalOpen}>
          <Header icon='history' content={Strings.RESTART_SYSTEM} />
          <Modal.Content>
            <p>{Strings.CONFIRM_RESTART_SYSTEM}</p>
          </Modal.Content>
          <Modal.Actions>
            <Button color='red' onClick={this.hideRestartSystemModal}><Icon name='remove' />{Strings.NO}</Button>
            <Button color='green' onClick={this.handleRestartSystemModalPositiveClick}><Icon name='checkmark' />{Strings.YES}</Button>
          </Modal.Actions>
        </Modal>

        <Modal basic size='small' open={this.state.isNtpModalOpen}>
          <Header icon='power' content={Strings.TURN_NTP_SERVER_ON} />
          <Modal.Content>
            <p>{Strings.TURN_NTP_SERVER_ON_QUESTION}</p>
          </Modal.Content>
          <Modal.Actions>
            <Button
              color='red'
              onClick={this.hideNtpModal}>
              <Icon name='remove' />
              {Strings.NO}
            </Button>
            <Button
              color='green'
              onClick={this.handleTurnNtpServerOnModalPositiveClick}>
              <Icon name='checkmark' />
              {Strings.YES}
            </Button>
          </Modal.Actions>
        </Modal>

        <Dimmer page active={isUpdateDimmerActive}>
          <UpdateLoader ref={this.updateLoaderRef} />
        </Dimmer>
      </div >
    );
  }
}

const formStyle = {
  marginTop: "24px",
  textAlign: "center",
  width: "100%"
};

const updateSegmentStyle = {
  textAlign: "center"
};

const labelStyle = {
  width: "20%"
};

const inputStyle = {
  width: "70%"
};

const logoutButtonContainer = {
  textAlign: "right"
};

const logoutButtonStyle = {
  marginBottom: "1em"
};

const configPageStyle = {
  margin: "2vh 2vw",
  textAlign: "center",
};

const questionIconStyle = {
  marginLeft: "4px"
};

export default withRouter(Configuration);
